<template>
    <div class="main Ssdt">
        <Titledx text="事件受理环比" />
        <div id="echart_x"></div>
    </div>
</template>
<script>
import Titledx from "./components/title";
import miment from "miment";
import echarts from "echarts";

export default {
    components: {
        Titledx,
    },
    data() {
        return {};
    },
    methods: {
        getToken() {
            let formData = new FormData();
            formData.append("username", "dongxiang");
            formData.append("password", "dxq!@123456@!");
            this.$post(this.urlobj.dx_dl, formData).then((res) => {
                localStorage.token = res.newPrimaryKeys.token;
                this.$store.commit("updateToken", res.newPrimaryKeys.token);
                this.getData();
            });
        },
        async getData() {
            let option = {
                color: ["rgba(0, 160, 233, 1)", "rgba(255, 162, 74, 1)"],
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
                    },
                },
                legend: {
                    data: [],
                    textStyle: {
                        //图例文字的样式
                        color: "#fff", //文字颜色
                        fontSize: 18,
                    },
                    itemHeight: 15,
                    itemWidth: 15,
                },
                grid: {
                    left: "100px",
                    right: "100px",
                    bottom: 0,
                    top: 90,
                    containLabel: true,
                },
                xAxis: [
                    {
                        name: "日",
                        nameTextStyle: {
                            color: "#fff",
                            fontSize: 18,
                        },
                        type: "category",
                        data: [],
                        axisLabel: {
                            color: "#b0b0b0",
                            fontSize: 12,
                            // formatter: (value=>{
                            //     return this.$util.autoSplit(value)
                            // }),
                        },
                        axisLine: { show: false },
                        splitLine: { show: false }, //去除网格线
                    },
                ],
                yAxis: [
                    {
                        name: "件",
                        nameTextStyle: {
                            color: "#fff",
                            fontSize: 18,
                        },
                        type: "value",
                        axisLabel: {
                            color: "#b0b0b0",
                            fontSize: 12,
                        },
                        axisLine: { show: false },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,.3)",
                            },
                        }, //去除网格线
                        // splitNumber:this.isSmallWidth?3:5
                    },
                ],
                series: [
                    {
                        name: "2020年11月",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        data: [],

                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#4884FF", // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.5,
                                        color: "rgba(6, 27, 84, 0)", // 100% 处的颜色
                                    },
                                ],
                                global: false, // 缺省为 false
                            },
                        },
                    },
                    {
                        name: "2020年12月",
                        type: "line",
                        smooth: true,
                        symbol: "none",
                        data: [],

                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#FFCD9D", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(6, 27, 84, 0)", // 100% 处的颜色
                                    },
                                ],
                                global: false, // 缺省为 false
                            },
                        },
                    },
                ],
            };

            var url = this.urlobj.dx_sjsl + "?type=dxsjslhb&times=202012";
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                option.xAxis[0].data = data.map((item) => item.name);

                option.legend.data = data[0].dataArr.map(
                    (items) => items.times
                );
                option.series[0].name = data[0].dataArr[0].times;
                option.series[1].name = data[0].dataArr[1].times;
                let data1 = [];
                data.forEach((itemx) =>
                    data1.push(
                        itemx.dataArr.find((item) => {
                            return item.times == option.series[0].name;
                        }).count
                    )
                );
                option.series[0].data = data1;

                let data2 = [];
                data.forEach((itemx) =>
                    data2.push(
                        itemx.dataArr.find((item) => {
                            return item.times == option.series[1].name;
                        }).count
                    )
                );
                option.series[1].data = data2;

                let myChart = echarts.init(document.getElementById("echart_x"));
                myChart.setOption(option);
            });
        },
    },
    created() {},
    mounted() {
        if(this.$store.state.access_token){
            this.getData();
        }else{
            this.getToken();
        }

        // document.getElementsByClassName("Ssdt")[0].style.zoom = 0.5;
        // let huanjing = window.location.href.split("//")[1].split("/")[0];
        // console.log(huanjing);
        // window.btnclick = function (type) {
        //     if (type == "goback") {
        //         if (huanjing == "ct.shequyun.cn") {
        //             window.open(
        //                 "https://ceshi.shequyun.cn/#/moduleList",
        //                 "_self"
        //             );
        //         } else {
        //             window.open(`https://${huanjing}/#/moduleList`, "_self");
        //         }
        //     }
        // };
    },
};
</script>
<style lang="less" scoped>
#echart_x {
    margin: 140px 0;
    height: 670px;
}
</style>